export const createLink = (stringData: Blob): string => {
  return URL.createObjectURL(stringData);
};
